<div
  class="popover-container"
  (click)="$event.stopPropagation()"
  *ngIf="popOverData"
>
  <!-- Header -->
  <div class="popover-header">
    <div class="header-content">
      <span class="pop-title">Trip Summary</span>
      <button class="close-btn" aria-label="Close" mat-dialog-close>
        <span class="close-icon">×</span>
      </button>
    </div>
  </div>

  <!-- Main Content Grid -->
  <div class="main-content">
    <!-- Left Column -->
    <div class="left-column">
      <!-- Trip Overview Card -->
      <div class="trip-overview-card">
        <div class="card-header">
          <div class="trip-meta">
            <div class="card-title">Trip Overview</div>
            <span class="trip-id"
              ><span class="trip-label">Trip ID:&nbsp;</span
              >{{ popOverData?.tripInfo?.tripId }}</span
            >
            <span class="vehicle-id"
              ><span class="trip-label">VIN:&nbsp;</span
              >{{ popOverData?.tripInfo?.vehicleId }}</span
            >
          </div>
                  <!-- Vehicle Image -->
          <div class="vehicle-section">
            <img
              [src]="
                popOverData?.tripInfo?.imageUrl ||
                'assets/images/summary-dummy-truck.png'
              "
              alt="vehicle"
              class="vehicle-image"
            />
          </div>
        </div>

        <!-- Route Information -->
        <div class="route-info">
          <div class="location-row">
            <div class="location-details">
              <span class="location-label location-indicator start"
                >Start Location</span
              >
              <p class="location-address">
                {{ popOverData?.tripInfo?.startLocation }}
              </p>
              <span class="location-date">{{
                popOverData?.tripInfo?.startTime
              }}</span>
            </div>
          </div>

          <div class="location-row">
            <div class="location-details">
              <span class="location-label location-indicator end"
                >End Location</span
              >
              <p class="location-address">
                {{ popOverData?.tripInfo?.endLocation }}
              </p>
              <span class="location-date">{{
                popOverData?.tripInfo?.endTime
              }}</span>
            </div>
          </div>
        </div>

        <!-- Trip Stats Grid -->
        <div class="trip-stats-grid">
          <div class="stat-card">
            <div class="stat-value">
              {{ (popOverData?.tripInfo?.distance || popOverData?.tripInfo?.distance === 0) ? popOverData?.tripInfo?.distance : '0' }} km
            </div>
            <div class="stat-label">Distance</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">
              {{
                popOverData?.tripInfo?.duration ||
                popOverData?.tripInfo?.duration === 0
                  ? (+popOverData?.tripInfo?.duration | duration)
                  : "0 min"
              }}
            </div>
            <div class="stat-label">Duration</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">
              {{ (tripOptimizationData?.calculations?.possibleRange || tripOptimizationData?.calculations?.possibleRange === '0' )? tripOptimizationData?.calculations?.possibleRange : '0' }} km
            </div>
            <div class="stat-label">Range Left</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">
              {{ (totalEnergyUsed || totalEnergyUsed === 0.00) ? totalEnergyUsed : '0' }} kWh
            </div>
            <div class="stat-label">Energy Used</div>
          </div>
        </div>
      </div>
      <div class="status-cards-container">
            <!-- First row of 4 cards -->
  <div class="status-cards-grid">
    <div 
      *ngFor="let card of statusData.slice(0, 4); trackBy: trackByFn" 
      class="status-card">
      <div class="icon-container _{{card?.id}}">
      </div>
      <div class="value-container">
        <span class="value">{{ card.value || card.value === 0 ? card.value : '0'}}</span>
        <span *ngIf="card.unit" class="unit">{{ card.unit }}</span>
      </div>
      <div class="label">{{ card.label }}</div>
    </div>
  </div>
  
  <!-- Second row of 4 cards -->
  <div class="status-cards-grid">
    <div 
      *ngFor="let card of statusData.slice(4, 8); trackBy: trackByFn" 
      class="status-card">
      <div class="icon-container _{{card?.id}}">
      </div>
      <div class="value-container">
        <span class="value">{{ card.value || card.value === 0 ? card.value : '--' }}</span>
        <span *ngIf="card.unit" class="unit">{{ card.unit }}</span>
      </div>
      <div class="label">{{ card.label }}</div>
    </div>
  </div>
      </div>
      <div class="tile2-wrapper" *ngIf="false">
        <!-- Driving Events Card -->
        <div class="events-card">
          <span class="card-title driving-events"> Driving Events </span>
          <div class="events-list">
            <div class="event-item harsh-braking">
              <span class="event-icon"></span>
              <span class="event-label">Harsh Braking</span>
              <span class="event-count">2 events</span>
            </div>
            <div class="event-item harsh-acceleration">
              <span class="event-icon"></span>
              <span class="event-label">Harsh Acceleration</span>
              <span class="event-count">1 event</span>
            </div>
            <div class="event-item overspeed">
              <span class="event-icon"></span>
              <span class="event-label">Overspeed</span>
              <span class="event-count">1 event</span>
            </div>
            <div class="event-item idle-time">
              <span class="event-icon"></span>
              <span class="event-label">Idle Time</span>
              <span class="event-count">8 min</span>
            </div>
          </div>
        </div>
        <!-- Thermal Status Card -->
        <div class="thermal-card">
          <span class="card-title thermal-status"> Thermal Status </span>
          <div class="thermal-list">
            <div class="thermal-item">
              <span class="thermal-label">Battery Temp</span>
              <div class="thermal-value">
                <div class="status-bar good"></div>
                <span class="value">32°C</span>
              </div>
            </div>
            <div class="thermal-item">
              <span class="thermal-label">Motor Temp</span>
              <div class="thermal-value">
                <div class="status-bar warning"></div>
                <span class="value">68°C</span>
              </div>
            </div>
            <div class="thermal-item">
              <span class="thermal-label">Inverter Temp</span>
              <div class="thermal-value">
                <div class="status-bar good"></div>
                <span class="value">38°C</span>
              </div>
            </div>
            <div class="thermal-item">
              <span class="thermal-label">Ambient Temp</span>
              <div class="thermal-value">
                <div class="status-bar good"></div>
                <span class="value">22°C</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="right-column">
      <!-- Optimization Insights Card -->
      <div class="optimization-card">
        <span class="card-title optimization-title">Optimization Insights</span>

        <!-- Primary Optimization -->
        <div class="primary-optimization" *ngIf="tripOptimizationData?.calculations?.maxRange">
          <div class="optimization-badge">
            <span class="saving-wrapper">
              <span class="saving-container"><span
                class="savings"
                >{{ maxRange || '--' }}Km</span
              >
              <span class="improvement" *ngIf="getRangeImprovementDisplay()">{{getRangeImprovementDisplay()}}</span>
            </span>
              <p class="optimization-text">
                {{ popOverData?.optimizationTips?.[0]?.text || 'Estimated range gain with perfect score' }}
              </p>
            </span>
            <span class="optimization-icon primary"></span>
          </div>
        </div>

        <!-- Secondary Optimizations -->
        <div class="secondary-optimizations" *ngIf="tripOptimizationData?.optimizationTips?.length">
          <div
            class="optimization-item"
            *ngFor="
              let tip of tripOptimizationData?.optimizationTips?.slice(0,4);
              let i = index
            "
          >
            <div class="optimization-row">
              <span class="category">{{getOptimizationAttributesName(tip?.attributeName) || (tip?.attributeName | titlecase ) }}&nbsp;<span class="improvement" *ngIf="tip?.outcome">{{tip?.outcome}}</span></span>
              <span class="description">{{ tip?.text }}</span>
            </div>
          </div>

          <!-- Default items if no data -->
          <!-- <div
            class="optimization-item"
            *ngIf="
              !tripOptimizationData?.optimizationTips ||
              tripOptimizationData?.optimizationTips?.length <= 1
            "
          >
            <div class="optimization-row">
              <span class="category">Eco-Driving</span>
              <span class="description"
                >Drive efficiently with moderate acceleration (-50% mAX)</span
              >
            </div>
          </div>
          <div
            class="optimization-item"
            *ngIf="
              !tripOptimizationData?.optimizationTips ||
              tripOptimizationData?.optimizationTips?.length <= 2
            "
          >
            <div class="optimization-row">
              <span class="category">Regenerative Braking</span>
              <span class="description"
                >Adjust regenerative friction (0.1 to 20 km/h)</span
              >
            </div>
          </div>
          <div
            class="optimization-item"
            *ngIf="
              !tripOptimizationData?.optimizationTips ||
              tripOptimizationData?.optimizationTips?.length <= 3
            "
          >
            <div class="optimization-row">
              <span class="category">Thermal Management</span>
              <span class="description"
                >Optimize cabin cooling (speed of 3.5 km/h)</span
              >
            </div>
          </div>
          <div
            class="optimization-item"
            *ngIf="
              !tripOptimizationData?.optimizationTips ||
              tripOptimizationData?.optimizationTips?.length <= 4
            "
          >
            <div class="optimization-row">
              <span class="category">Route Optimization</span>
              <span class="description"
                >Minimize route temperature-wise (45.6°C)</span
              >
            </div>
          </div> -->
        </div>

        <div *ngIf="!tripOptimizationData?.optimizationTips?.length && !tripOptimizationData?.calculations?.maxRange" class="empty-state">
          <svg class="empty-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 6v6l4 2"></path>
          </svg>
          <p class="empty-text">No Insights available</p>
        </div>
      </div>

      <!-- Trip Performance Card -->
      <div class="trip-score-card">
        <!-- Header Section -->
        <div class="card-title trip-performance-title">Trip Performance</div>
        <div class="performance-header-section">
          <div class="score-circle-container">
            <!-- <svg class="score-circle" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" class="circle-background"></circle>
              <circle
                cx="50"
                cy="50"
                r="45"
                class="circle-progress"
                [style.stroke-dasharray]="strokeDasharray"
              ></circle>
            </svg> -->
            <app-doughnut-chart *ngIf="tripOptimizationData?.summary?.score || tripOptimizationData?.summary?.score === 0" class="chart" [series]="options?.series" [legend]="options?.legend"
              [graphic]="options?.graphic" [grid]="options?.grid"></app-doughnut-chart>

            <div class="score-content" *ngIf="!tripOptimizationData?.summary?.score && tripOptimizationData?.summary?.score!==0">
              --
            </div>
          </div>
          <div class="feedback-section-wrapper">
            <div class="feedback-section">
              <div class="feedback-text">
                <span class="trophy-icon">🏆</span>{{tripOptimizationData?.summary?.note ?? '--'}}
              </div>
            </div>
            <!-- Stats Section -->
            <div class="stats-section">
              <div class="stat-item">
                <span class="stat-label">vs Last Trip</span>
                <span class="stat-value positive">{{ scoreDiff != null ? (scoreDiff >= 0 ? '+' + scoreDiff : '-' + (scoreDiff * -1)) : '--' }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Efficiency Gain</span>
                <span class="stat-value positive">{{ efficiencyGain != null ? (efficiencyGain >= 0 ? '+' + efficiencyGain : '-' + (efficiencyGain * -1)) : '--' }}%</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Rankings Section -->
        <div class="rankings-section">
          <span class="rankings-title" *ngIf="trips?.length">Top 3 Trip Score</span>
          <div class="trips-list">
            <div
              *ngFor="let trip of trips, let i =index"
              class="trip-item"
              [ngClass]="{'trip-current': trip?.tripId === data?.tile1?.tripId}"
            >
              <div class="trip-rank">
                <span class="rank-number">#{{ i+1 }}</span>
              </div>
              <div class="trip-id" [matTooltip]="trip?.tripId">
                Trip&nbsp;{{ formatTripId(trip?.tripId) ?? 'Trip '+(i+1) }}
                <span *ngIf="trip?.tripId === data?.tile1?.tripId" class="current-label"
                  >&nbsp;(Current)</span>
              </div>
              <div
                class="trip-score"
                [ngClass]="trip.isCurrent ? 'current-score' : ''"
              >
                {{ trip?.modelOutput?.summary?.score ?? '--' }}
              </div>
            </div>

            <!--Current trip position-->
            <div
              class="trip-item trip-current"
              *ngIf="!currentTripIncluded"
            >
              <div class="trip-rank">
                <span class="rank-number">#{{ currentTripPosition }}</span>
              </div>
              <div class="trip-id" [matTooltip]="data?.tile1?.tripId">
                Trip&nbsp;{{ formatTripId(data?.tile1?.tripId) ?? 'Trip ' }}
                <span class="current-label"
                  >&nbsp;(Current)</span>
              </div>
              <div
                class="trip-score current-score"
              >
                {{ tripOptimizationData?.summary?.score ?? '--' }}
              </div>
            </div>
             <!--Current trip position-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
